import { BCMSDefaultModel, BCMSRecord, StateManager, useBCMSContext, useParams, useRoute, useStateManager } from '@bcm-dev/bcms-vite';
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import Classes from "model";
import React from "react";
import EnterSecurityTokenView from "../SecurityTokenPage/components/EnterSecurityTokenView";
import "./styles.css";

/**
 * @function EnterSecurityTokenPage
 * @return {React.Component}
 * @exported true
 * @description The main component for EnterSecurityTokenPage
 * @example
 * <EnterSecurityTokenPage />
 */
export default function EnterSecurityTokenPage(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const cardID = useParams().cardID ?? "0";
  const data = { ...getDefaultData(cardID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

return (
  <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
  </StateManager>
);
}

export const getDefaultData = cardID => {
  const cardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();

  return {
      cardID,
      cardOnFileMerchant
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui } = useStateManager();
  const navigate = useRoute();
  const _data = data ? { data: data } : {};
  const _ui = ui ? { ui: ui } : {};

  return (
    <MainContentContainer 
      className="security-token-page" 
      header={
        <MainContentHeader text="Security Token" onClick={ evt => navigate(`/home/recenttransactions/${ data.cardID }`) } />
      }>
      
      <EnterSecurityTokenView { ..._data } { ..._ui } />
    </MainContentContainer>
  );
}